import React, { useEffect, useState } from "react";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import CustomFileInput from "../../../Components/InputCompo/CustomFileInput";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import { Form, Formik, useFormik } from "formik";
import * as Yup from "yup";
import { m } from "framer-motion";
import { zoomIn } from "../../../Functions/GlobalAnimations";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
    initialSubRegistration,
    EngageSection5Get,
    EngageSection5Post,
    editRegistration,
} from "../../../Store/auth/register";
import { enqueueSnackbar } from "notistack";
import MultipleSelect from "../../../Components/SelectionComp/MultipleSelect";
import Loading from "../../../Components/Loader/Loading";
import { useLocation } from "react-router-dom";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ModalComp from "../../../Components/ModalComp";
import CloseIcon from "@mui/icons-material/Close";
import CustomTextarea from "../../../Components/textareaComp/CustomTextarea";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const SustainableDevelopment = ({ setSubTabs }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const application_no = localStorage.getItem("RegKey");
    const gsn_no = localStorage.getItem("gsn_no");
    const [tableValues, setTableValues] = useState();
    const [isCheckedAll, setIsCheckedAll] = useState(false);
    const DBName = localStorage.getItem("Db_name");
    const { isLoading: fieldLoading, data: questions } = useQuery({
        queryKey: "engageSec5Q",
        queryFn: () =>
            EngageSection5Get(
                application_no && DBName ? DBName : "Pending DB",
                application_no
            ),
        cacheTime: 1000 * 60 * 5,
        staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
    });
    if (!application_no) {
        setSubTabs({ "Get Started": true });
    }

    useEffect(() => {
        if (questions) {
            const filteredSections = questions?.documents?.filter(
                (ele) => ele?.type?.toLowerCase() === "section"
            );

            let tempTable = tableValues;
            filteredSections?.map(
                (ele) => (tempTable = { ...tempTable, [ele?.template]: [{}] })
            );
            setTableValues(tempTable);
        }
    }, [questions]);

    // validation for fields
    const modelSchema = Yup.object().shape({
        ...questions?.documents?.reduce((schema, fields) => {
            if (fields.type.toLowerCase() !== "section") {
                // Define validation rules
                let fieldValidation = Yup.string();

                // Apply different validation rules based on the field's validation type
                if (
                    fields.validation.toLowerCase() === "email" &&
                    !fields?.depend_question
                ) {
                    fieldValidation = fieldValidation.matches(
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        "Invalid email address"
                    );
                } else if (fields.validation.toLowerCase() === "pan") {
                    fieldValidation = fieldValidation.matches(
                        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        "Invalid PAN Number. It should be in the format: ABCDE1234F."
                    );
                } else if (fields.validation.toLowerCase() === "gst") {
                    fieldValidation = fieldValidation.matches(
                        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/,
                        "Invalid PAN Number. It should be in the format: ABCDE1234F."
                    );
                } else if (fields.validation.toLowerCase() === "pincode") {
                    fieldValidation = Yup.string().matches(
                        /^\d{4}$|^\d{6}$/,
                        "PIN code must be exactly 6 digits"
                    );
                } else if (fields.validation.toLowerCase() === "areacode") {
                    fieldValidation = fieldValidation.matches(
                        /^(123|456|789)$/,
                        "Incorrect area code"
                    );
                } else if (fields.type.toLowerCase() === "multiselect dropdown") {
                    fieldValidation = Yup.array();
                } else if (fields.validation.toLowerCase() === "website") {
                    fieldValidation = fieldValidation.url("Please enter a valid URL");
                } else if (fields.validation.toLowerCase() === "mobile") {
                    fieldValidation = fieldValidation.matches(
                        /^(?:[0-9]{10}|[0-9]{7})$/,
                        "Invalid contact number"
                    );
                } else if (fields.type.toLowerCase() === "attach") {
                    fieldValidation = Yup.object();
                } else if (fields.validation.toLowerCase() === "darpan") {
                    fieldValidation = fieldValidation.test(
                        "is-valid-darpan",
                        " Darpan Id should be in the format: XX/1234/1234567",
                        (value) => {
                            if (value?.toUpperCase() === "NA") {
                                return true;
                            }
                            return /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value);
                        }
                    );
                } else if (
                    fields.validation.toLowerCase() === "password" &&
                    !fields?.depend_question
                ) {
                    fieldValidation = fieldValidation.min(
                        8,
                        "Password must be at least 8 characters long"
                    );
                }

                // Apply required validation if the field is mandatory
                if (fields.mandatory === 1) {
                    fieldValidation = fieldValidation.required(
                        `${fields.question} is required`
                    );
                }

                // Assign the validation rule to the field in the schema
                schema[fields?.question_no] = fieldValidation;
            }

            return schema;
        }, {}),
    });

    const formik = useFormik({
        initialValues: questions?.documents?.reduce((values, fields) => {
            // Check if there's an answer for the current question_no

            const answer =
                questions?.docs_answers.length > 0
                    ? questions?.docs_answers?.find(
                        (ans) => ans.question_no === fields.question_no
                    )
                    : "";

            if (
                (answer?.answer &&
                    fields.type.toLowerCase() !== "section" &&
                    questions?.docs_answers.length > 0) ||
                (answer?.upload_document &&
                    questions?.docs_answers.length > 0 &&
                    fields.type.toLowerCase() !== "section")
            ) {
                if (fields.type.toLowerCase() === "checkbox") {
                    values[fields?.question_no] = answer?.answer === "Y" ? true : false; // Initialize with the answer if available
                } else {
                    values[fields?.question_no] = answer?.answer || {
                        fileName: answer?.upload_document,
                    }; // Initialize with the answer if available
                }
            } else {
                values[fields?.question_no] = ""; // Default to an empty string if no answer exists
            }

            return values;
        }, {}),
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const tempData = questions?.documents?.map((fields) => {
                    if (
                        fields?.type.toLowerCase() === "attach" &&
                        values?.[fields.question_no]
                    ) {
                        return {
                            question_no: fields?.question_no,
                            attach_file: values?.[fields?.question_no]?.file64,
                            file_name: values?.[fields?.question_no]?.fileName,
                        };
                    } else if (fields?.type.toLowerCase() === "number") {
                        return {
                            question_no: fields?.question_no,
                            answer: `${values[fields?.question_no]}`,
                        };
                    } else if (fields?.type.toLowerCase() === "checkbox") {
                        return {
                            question_no: fields?.question_no,
                            answer: `${values[fields?.question_no] ? "Y" : "N"}`,
                        };
                    } else if (
                        fields?.type.toLowerCase() === "multiselect dropdown" &&
                        values?.[fields?.question_no]
                    ) {
                        return {
                            question_no: fields?.question_no,
                            answer: `${values[fields?.question_no].map((ele) => {
                                return ele;
                            })}`,
                        };
                    } else {
                        return {
                            question_no: fields?.question_no,
                            answer: values[fields?.question_no],
                        };
                    }
                });

                const structuredData = {
                    args: {
                        name: application_no,
                        // brief_description: `We started our organisation in the year ${values?.['DRQ-00072']} and since then, served ${values?.['DRQ-00073']} number(s) of Accident ${values?.['DRQ-00074']} (communities/ entities) in the thematic areas of Culture and arts, Sports,Education in top state - districts of ${values?.['DRQ-00077']?.map(ele => { return ele })} and/ or pan India,  and use the key indicator(s)  ${values?.['DRQ-00079']?.map(ele => { return ele })} to track our progress Verified (all of which can be ${values?.['DRQ-00079']} independently/ some of which can be be verified independently/ none of which can be verified independently), and hope to reach our goal of sss by around the year 2100.`,
                        engage_level_section_5: tempData,
                    },
                };

                await CheckTableFields(structuredData);
            } catch (error) {
                console.error(error);
            } finally {
                setSubmitting(false);
            }
        },
    });

    // file handling manually

    const fileHandler = (e) => {
        const file = e?.target?.files[0];
        const name = e?.target?.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                formik.setFieldValue(name, {
                    file64: base64String,
                    fileName: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // error handling mutation

    const handleCreateSuccess = () => {
        setTimeout(() => {
            setSubTabs({ "Other organisation details": true });
        }, 1000);
        enqueueSnackbar("success!", { variant: "success" });
    };

    const handleCreateError = (error) => {
        if (error?.response?.data.status_code >= 500) {
            enqueueSnackbar(error?.response?.data?.status_message, {
                variant: "error",
            });
        } else {
            enqueueSnackbar(error?.response?.data?.message || error?.message, {
                variant: "error",
            });
        }
    };

    const createFarmerMutationOptions = {
        onSuccess: handleCreateSuccess,
        onError: handleCreateError,
    };

    // checking table fields manually
    const CheckTableFields = (data) => {
        // Filter all sections from questions.documents where type is 'section'
        const sections = questions?.documents?.filter(
            (ele) => ele.type.toLowerCase() === "section"
        );

        // Check if sections are found
        if (!sections || sections.length === 0) {
            discoverPanReg(data);
            return;
        }

        let emptyField = null;

        // Iterate over each section
        for (let section of sections) {
            if (!section.sub_questions || section.sub_questions.length === 0) {
                enqueueSnackbar("Sub-questions not found in a section", {
                    variant: "error",
                });
                return; // Stop processing if any section is missing sub-questions
            }

            // Find the corresponding key in tableValues for the current section's template
            const tableKey = Object.keys(tableValues).find(
                (key) => key === section.template
            );

            if (!tableKey) {
                enqueueSnackbar(
                    `No matching table values found for section with template ${section.template}`,
                    { variant: "error" }
                );
                return; // Stop if there is no matching table value for the section
            }

            // Get the table data for this section
            const tableData = tableValues[tableKey];

            // Iterate over each sub_question in the section
            for (let subq of section.sub_questions) {
                // Check if the sub_question is marked as mandatory
                if (subq.mandatory > 0) {
                    // Check each row in the corresponding table data for this section
                    for (let row of tableData) {
                        // Check if the mandatory field in this row is empty
                        if (!row[subq.question_no]) {
                            // If a required field is found empty, set it and break the loop
                            emptyField = subq.question;
                            break;
                        }
                    }

                    // If an empty field is found, break out of the loop
                    if (emptyField) {
                        break;
                    }
                }
            }

            // If an empty field is found, stop further checks
            if (emptyField) {
                break;
            }
        }

        if (emptyField) {
            // Notify the user about the missing field
            enqueueSnackbar(
                `Field "${emptyField}" is required. Please fill it out.`,
                { variant: "warning" }
            );
        } else {
            // Proceed with the actions if all mandatory fields are filled
            discoverPanReg(data);
            submitTable();
        }
    };

    const { mutate: discoverPanReg, isPending: PendingDiscoverPan } = useMutation(
        {
            mutationFn: EngageSection5Post,
            ...createFarmerMutationOptions,
        }
    );

    // handle the conditions in backend data

    const evaluateCondition = (value1, condition, value2) => {
        switch (condition) {
            case "==":
                return value1 == value2; // Using loose equality as per original suggestion
            case "===":
                return value1 === value2;
            case "!==":
                if (value1 !== value2) {
                    return false;
                }
            case ">":
                return value1 > value2;
            case "<":
                return value1 < value2;
            case ">=":
                return value1 >= value2;
            case "<=":
                return value1 <= value2;
            default:
                return false;
        }
    };

    // table delete rows

    const DeleteRows = (section) => {
        let tempValues = [...tableValues?.[section]];
        let deleteArray = [];
        tableValues?.[section].map((ele, index) => {
            if (ele?.check) {
                deleteArray.push(index);
            }
        });

        deleteArray.sort((a, b) => b - a);
        deleteArray.forEach((index) => {
            tempValues.splice(index, 1);
        });
        setTableValues({ ...tableValues, [section]: tempValues });
    };

    // table add rows and check mandatory fields and waring messages

    const addRow = (Qnm, section) => {
        const findTable = questions?.documents?.find(
            (ele) => ele.question_no === Qnm
        );

        if (!findTable || !findTable.sub_questions) {
            enqueueSnackbar("Table or sub-questions not found", { variant: "error" });
            return;
        }

        let emptyField = null;

        // Check if any mandatory field is empty in the current rows and identify the first empty one
        findTable.sub_questions.some((subq) => {
            if (subq.mandatory > 0) {
                const emptyValue = tableValues?.[section]?.some((values) => {
                    if (!values[subq.question_no]) {
                        emptyField = subq.question;
                        return true;
                    }
                    return false;
                });
                if (emptyValue) return true;
            }
            return false;
        });
        if (emptyField) {
            enqueueSnackbar(
                `Field "${emptyField}" is required. Please fill it out.`,
                { variant: "warning" }
            );
        } else {
            setTableValues({
                ...tableValues,
                [section]: [...tableValues?.[section], {}],
            });
        }
    };

    // table checkbox for delete

    const CheckAllFields = (e, index, section) => {
        let tempValues = [...tableValues?.[section]];

        if (typeof index === "undefined") {
            setIsCheckedAll(!isCheckedAll);
            tempValues = tempValues.map((ele) => ({
                ...ele,
                check: !isCheckedAll,
            }));
        } else {
            tempValues[index] = {
                ...tempValues[index],
                check: !tempValues[index].check,
            };
        }
        const findChecked = tempValues.filter((ele) => ele.check);
        if (findChecked.length === tempValues.length) {
            setIsCheckedAll(true);
        } else {
            setIsCheckedAll(false);
        }
        setTableValues({ ...tableValues, [section]: tempValues });
    };

    const tableValuesUpdate = async (e, index, section) => {
        try {
            const value = e?.target?.value;
            const name = e?.target?.name;
            let tempData = [...tableValues?.[section]];

            if (e?.target.type === "file") {
                const file = e?.target?.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        const base64String = reader.result.split(",")[1];
                        // Update tempData with the new file data
                        tempData[index] = {
                            ...tempData[index],
                            [name]: { file64: base64String, fileName: file.name },
                        };
                        // Set state after reading is complete
                        setTableValues((prevValues) => ({
                            ...prevValues,
                            [section]: tempData,
                        }));
                    };
                    reader.readAsDataURL(file);
                }
            } else {
                // Handle non-file input types
                tempData[index] = {
                    ...tempData[index],
                    [name]: value,
                };
                // Directly update state for non-file input
                setTableValues((prevValues) => ({
                    ...prevValues,
                    [section]: tempData,
                }));
            }
        } catch (error) { }
    };

    // manual submission table

    const submitTable = async () => {
        try {
            const keys = Object.keys(tableValues);
            const mutations = keys.map(async (key) => {
                let TempTable = tableValues?.[key];
                if (TempTable) {
                    const main_question_no = questions?.documents?.find(
                        (field) =>
                            field.type.toLowerCase() === "section" && field.template === key
                    );

                    let passedValues = {
                        args: {
                            reg_name: application_no,
                            main_question_no: main_question_no?.question_no,
                            question_answers: [],
                        },
                    };

                    TempTable.forEach((ele, index) => {
                        let tempQuestion_answers = [];
                        main_question_no.sub_questions.forEach((field) => {
                            if (
                                field?.type.toLowerCase() === "multiselect dropdown" &&
                                ele?.[field?.question_no]
                            ) {
                                tempQuestion_answers.push({
                                    question_no: field?.question_no,
                                    answer: `${ele?.[field?.question_no].map((ele) => ele)}`,
                                });
                            } else if (
                                field?.type.toLowerCase() === "attach" &&
                                ele?.[field?.question_no]
                            ) {
                                tempQuestion_answers.push({
                                    question_no: field?.question_no,
                                    file_name: ele[field?.question_no]?.fileName,
                                    attach_file: ele[field?.question_no]?.file64,
                                });
                            } else {
                                tempQuestion_answers.push({
                                    question_no: field?.question_no,
                                    answer: ele[field?.question_no],
                                });
                            }
                        });
                        passedValues.args.question_answers[index] = tempQuestion_answers;
                    });

                    if (passedValues.args.question_answers.length > 0) {
                        await submitSubReg(passedValues);
                    }
                }
            });

            // Wait for all mutations to complete
            await Promise.allSettled(mutations);
        } catch (error) { }
    };

    const { mutate: submitSubReg, isPending: subLoading } = useMutation({
        mutationFn: initialSubRegistration,
        ...createFarmerMutationOptions,
    });

    const selectedValues = (name, values, index, section) => {
        let tempTable = [...tableValues?.[section]];
        tempTable[index] = { ...tempTable[index], [name]: values };
        setTableValues({ ...tableValues, [section]: tempTable });
    };

    // waiting for fields
    //

    const updateMultiSelect = (e, value) => {
        const question_no = e?.target?.name;

        // Get the current values from Formik or set to an empty array if undefined
        let tempFormik = formik?.values?.[question_no] || [];

        // Ensure the value is a valid string and not split into characters
        if (typeof value === "string") {
            // Check if the value already exists in the array
            if (tempFormik?.includes(value)) {
                // If it exists, remove the value
                tempFormik = tempFormik?.filter((v) => v !== value);
            } else {
                // If it does not exist, add the value
                tempFormik = [...tempFormik, value];
            }
        } else {
            console.error("Invalid value type. Expected a string.");
        }

        // Update Formik field value
        if (formik?.values?.[question_no]?.length < 3) {
            formik?.setFieldValue(question_no, tempFormik);
        } else {
            enqueueSnackbar("You can select up to 3 options only.", {
                variant: "warning",
            });
        }
    };
    const updateModalMultiSelect = (
        e,
        value,
        setModalFieldValue,
        modalValues
    ) => {
        console.log("modalValues>>>>>", e,
            value,
            setModalFieldValue,
            modalValues);
        const question_no = e?.target?.name;

        // Get the current values from Formik or set to an empty array if undefined
        let tempFormik = modalValues?.[question_no] || [];

        // Ensure the value is a valid string and not split into characters
        if (typeof value === "string") {
            // Check if the value already exists in the array
            if (tempFormik.includes(value)) {
                // If it exists, remove the value
                tempFormik = tempFormik.filter((v) => v !== value);
            } else {
                // If it does not exist, add the value
                tempFormik = [...tempFormik, value];
            }
        } else {
            console.error("Invalid value type. Expected a string.");
        }

        // Update Formik field value
        if (
            modalValues?.[question_no]?.length < 3 ||
            !tempFormik?.includes(value)
        ) {
            setModalFieldValue(question_no, tempFormik);
        } else {
            enqueueSnackbar("You can select up to 3 options only.", {
                variant: "warning",
            });
        }
    };

    const attachFile = (e, setFieldValue) => {
        if (!e.target.files || e.target.files.length === 0) {
            setFieldValue(e.target.name, "");
            return; // Prevent further execution if no file is selected
        }
        const file = e.target.files[0];
        const name = e.target.name;
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                setFieldValue(name, {
                    attach_file: base64String,
                    file_name: file.name,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    // waiting for fields

    const commonEditOpenModal = (
        name,
        data,
        values,
        type,
        template,
        sub_question_num,
        subQuestion
    ) => {
        setIsModalOpen({
            [name]: true,
            data,
            values,
            type: type,
            template: template,
            sub_question_num: sub_question_num,
            subQuestion,
        });
    };
    const editModalSchema = Yup.object().shape({
        [isModalOpen?.data?.question_no]: (() => {
            let validation = Yup.string();

            // Check if isModalOpen?.data is defined
            if (!isModalOpen?.data) return validation;

            const fieldType = isModalOpen.data.type?.toLowerCase();
            const fieldValidation = isModalOpen.data.validation?.toLowerCase();

            // Apply validation based on `validation` property
            if (fieldValidation === "email" && !isModalOpen.data?.depend_question) {
                validation = validation.matches(
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    "Invalid email address"
                );
            } else if (fieldValidation === "pan") {
                validation = validation.matches(
                    /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                    "Invalid PAN Number. Format: ABCDE1234F."
                );
            } else if (fieldValidation === "pincode") {
                validation = validation.matches(
                    /^\d{4}$|^\d{6}$/,
                    "PIN code must be exactly 4 or 6 digits"
                );
            } else if (fieldValidation === "mobile") {
                validation = validation.matches(
                    /^(?:[0-9]{10}|[0-9]{7})$/,
                    "Invalid contact number"
                );
            } else if (fieldValidation === "website") {
                validation = validation.url("Please enter a valid URL");
            } else if (fieldValidation === "darpan") {
                validation = validation.test(
                    "is-valid-darpan",
                    "Darpan ID should be in the format: XX/1234/1234567",
                    (value) =>
                        value?.toUpperCase() === "NA" ||
                        /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                );
            } else if (
                fieldValidation === "password" &&
                !isModalOpen.data?.depend_question
            ) {
                validation = validation.min(
                    8,
                    "Password must be at least 8 characters long"
                );
            } else if (fieldType === "multiselect dropdown") {
                validation = Yup.array().of(Yup.string());
            } else if (fieldType === "attach") {
                validation = Yup.object();
            }

            // Apply 'required' validation if `mandatory` is 1
            if (isModalOpen.data.mandatory === 1) {
                validation = validation.required(
                    `${isModalOpen.data.question} is required`
                );
            }

            return validation;
        })(),
    });
    const commonEditCloseModal = () => {
        if (!editLoading) {
            setIsModalOpen("");
        }
    };

    console.log(
        "docs>>>",
        questions?.documents?.find((doc) => doc?.type?.toLowerCase() === "section")
            ?.template
    );

    const hasAnswerForQuestion = (subQ) => {
        let answer = ''
        const doc = questions?.docs_answers?.length > 0 && questions?.docs_answers?.find(doc => doc?.type.toLowerCase() === 'section');
        // Find the answer element that contains the question with the matching question number
        doc?.answer?.map(ele => {
            answer = ele.find(dt => dt?.question_no === subQ?.question_no)?.answer || ele.find(dt => dt?.question_no === subQ?.question_no)?.upload_document
        }
        );
        return answer;
    };

    const updateValues = async (values) => {
        try {

            const currentDate = await new Date()
            const structuredData = await
                {
                    args: {
                        gsn_number: gsn_no,
                        date_and_time: formatDateTime(currentDate),
                        gsi_id: application_no,
                        question_id: isModalOpen?.data?.question_no,
                        question_text: isModalOpen?.data?.question,
                        previous_answer: questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer,
                        edited_answer:
                            isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown" ?
                                `${values?.[isModalOpen?.data?.question_no].map(ele => { return ele })}`
                                :
                                values?.[isModalOpen?.data?.question_no],
                        section_name: 'Engage Details'

                    }
                }
            console.log("structuredData>>>>", structuredData)

            await editData(structuredData)

        } catch (error) {

        }

    };
    const formatDateTime = (isoString) => {
        const date = new Date(isoString);

        // Extract YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
        const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits

        // Extract HH:MM:SS in 24-hour format
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const { mutate: editData, isPending: editLoading } = useMutation({
        mutationFn: editRegistration,
        ...createFarmerMutationOptions,
        onMutate: async () => {
            // Cancel the current query before mutating
            // await queryClient.cancelQueries(['Questions', application_no]);
        },
        onSuccess: () => {
            // Invalidate the query to refetch the latest data
            // queryClient.invalidateQueries(['Questions', application_no]);
        },
    });
    const modalMultiSelectedValues = (values, setModalFieldValue) => {
        const fieldPath = `normalFields.${isModalOpen?.data?.question_no}`;
        setModalFieldValue(fieldPath, values?.[isModalOpen?.data?.question_no]);
        commonEditCloseModal();
    };

    useEffect(() => {
        if (!editLoading) {
            setIsModalOpen("");
        }
    }, [editLoading]);

    if (PendingDiscoverPan || subLoading || fieldLoading) return <Loading />;

    return (
        <>
            <form
                className="flex flex-col gap-[30px]"
                onSubmit={formik.handleSubmit}
                action=""
            >
                <div className="flex flex-wrap gap-[30px] justify-between w-[100%]">
                    {questions?.documents.map((Fields) => (
                        <>
                            {Fields.type.toLowerCase() === "text" ||
                                Fields.type.toLowerCase() === "number" ||
                                Fields.type.toLowerCase() === "date" ||
                                Fields.type.toLowerCase() === "password" ? (
                                <div
                                    className={`${Fields.condition
                                        ? !evaluateCondition(
                                            formik?.values?.[Fields?.depend_question],
                                            Fields.condition,
                                            Fields.value
                                        ) &&
                                        Fields?.depend_question &&
                                        "hidden"
                                        : ""
                                        } ${Fields?.question.toLowerCase() === "comment box"
                                            ? "w-[100%]"
                                            : " w-[48%]"
                                        }  `}
                                >
                                    <div>
                                        <CustomInput
                                            required={Fields?.mandatory > 0 ? true : false}
                                            {...formik.getFieldProps(Fields.question_no)}
                                            type={Fields.type.toLowerCase()}
                                            name={Fields.question_no}
                                            label={Fields.question}
                                        />
                                        <ParagraphComp
                                            className="text-[red] text-[10px] px-[8px] mt-1"
                                            text={
                                                formik.values?.[Fields.question_no] &&
                                                formik.errors?.[Fields.question_no]
                                            }
                                        />
                                        <ParagraphComp
                                            className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                                            text={Fields.description}
                                        />
                                    </div>
                                </div>
                            ) : Fields.type.toLowerCase() === "dropdown" ? (
                                <div
                                    className={`${Fields?.condition
                                        ? !evaluateCondition(
                                            formik?.values?.[Fields?.depend_question],
                                            Fields.condition,
                                            Fields.value
                                        ) &&
                                        Fields?.depend_question &&
                                        "hidden"
                                        : ""
                                        } w-[48%]`}
                                >
                                    <div>
                                        <>
                                            <CustomSelection
                                                required={Fields?.mandatory > 0 ? true : false}
                                                options={Fields?.options}
                                                {...formik.getFieldProps(Fields.question_no)}
                                                name={Fields.question_no}
                                                label={Fields.question}
                                            />
                                            <ParagraphComp
                                                className="text-[red] text-[10px] px-[8px] mt-1"
                                                text={
                                                    formik.values?.[Fields.question_no] &&
                                                    formik.errors?.[Fields.question_no]
                                                }
                                            />
                                            <ParagraphComp
                                                className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                                                text={Fields.description}
                                            />{" "}
                                        </>
                                    </div>
                                </div>
                            ) : Fields.type.toLowerCase() === "attach" ? (
                                <div
                                    className={`${Fields?.condition
                                        ? !evaluateCondition(
                                            formik?.values?.[Fields?.depend_question],
                                            Fields.condition,
                                            Fields.value
                                        ) &&
                                        Fields?.depend_question &&
                                        "hidden"
                                        : ""
                                        } w-[48%]`}
                                >
                                    <div>
                                        <>
                                            <CustomFileInput
                                                options={Fields?.options}
                                                required={Fields?.mandatory > 0 ? true : false}
                                                onChange={fileHandler}
                                                value={formik.values?.[Fields.question_no]?.fileName}
                                                name={Fields.question_no}
                                                label={Fields.question}
                                            />
                                            <ParagraphComp
                                                className="text-[red] text-[10px] px-[8px] mt-1"
                                                text={
                                                    formik.values?.[Fields.question_no] &&
                                                    formik.errors?.[Fields.question_no]
                                                }
                                            />
                                            <ParagraphComp
                                                className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                                                text={Fields.description}
                                            />{" "}
                                        </>
                                    </div>
                                </div>
                            ) : Fields?.type.toLowerCase() === "multiselect dropdown" ? (
                                <>
                                    <div className="w-[100%]">
                                        <HeaderCompo
                                            tagType="h3"
                                            className="text-2xl mb-[10px]"
                                            text={Fields.question}
                                        />
                                        <ParagraphComp
                                            tagType="h3"
                                            className="text-xl "
                                            text={Fields.paremeter}
                                        />
                                    </div>
                                    <div className="w-[100%] flex gap-[20px] flex-wrap">
                                        {Fields?.options?.map((subQ, multiIndex) => (
                                            <div className="flex gap-[10px] w-[30%]">
                                                <div className=" w-[100%]">
                                                    <label className="flex mt-[16px] items-center space-x-2">
                                                        <div className="w-[20px] h-[20px]">
                                                            <InputCompo
                                                                // disabled={questions?.docs_answers?.length > 0}
                                                                required={subQ?.mandatory > 0 ? true : false}
                                                                options={subQ?.options}
                                                                onChange={(e) =>
                                                                    updateMultiSelect(e, subQ.option)
                                                                }
                                                                checked={
                                                                    formik?.values?.[
                                                                        Fields?.question_no
                                                                    ]?.includes(subQ?.option)
                                                                        ? true
                                                                        : false
                                                                }
                                                                name={Fields.question_no}
                                                                className="bg-[#004878] text-white w-[20px] h-[20px]"
                                                                type="checkbox"
                                                            />
                                                        </div>

                                                        <span className='text-black'>{subQ.option}</span>
                                                    </label>
                                                </div>
                                                {/* {(questions?.docs_answers?.length > 0 && gsn_no && questions?.docs_answers?.some(doc => doc?.answer)) && multiIndex + 1 === Fields?.options?.length ?
                                                    <div className="flex gap-[10px] mt-[8px]">
                                                        <div onClick={() => commonEditOpenModal('edit', Fields, formik?.values)} className=" cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]">
                                                            <BorderColorIcon className="text-white" />
                                                        </div>
                                                        <div onClick={() => commonEditOpenModal('comment', Fields, formik?.values)} className="bg-[#004878] relative h-fit rounded-full p-[8px]">
                                                            {
                                                                (questions?.docs_answers?.length > 0 &&
                                                                    questions?.docs_answers?.find(doc => doc?.question_no === Fields?.question_no)?.comments_for_npo)
                                                                &&
                                                                <div className="absolute z-10 bg-[red] mt-[-15px] ml-[17px] rounded-full p-[1px] ">
                                                                    <NotificationsActiveIcon className=" text-[#ffffff]" />
                                                                </div>
                                                            }
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                        </div>
                                                    </div>
                                                    : ''
                                                } */}
                                            </div>
                                        ))}
                                    </div>
                                </>)
                                : ''
                            }
                            {
                                Fields.type.toLowerCase() === 'section' ?
                                    <>
                                        <div className='w-[100%]'>
                                            <div className='p-[20px] w-[100%] border-b-transparent border-2 rounded-t-xl flex items-center justify-between'>
                                                <HeaderCompo className='text-xl text-black mt-0 m-0' tagType='h3' text={Fields.template} />
                                                <div className='flex gap-[20px]'>
                                                    {
                                                        tableValues?.[Fields?.template]?.find(ele => ele?.check) &&
                                                        <m.div {...zoomIn}>
                                                            <ButtonComp type='button' onClick={() => { DeleteRows(Fields?.template) }} text={<i class="fa-regular fa-trash-can text-white"></i>} className='px-[20px] h-[40px] text-white bg-[red] rounded-full py-[5px]' />
                                                        </m.div>
                                                    }
                                                    <ButtonComp type='button' onClick={() => addRow(Fields.question_no, Fields.template)} text='Add' className='px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px]' />
                                                </div >
                                            </div >
                                            <div className='border-2 scrollbar-thin  overflow-x-auto'>
                                                <table className=' table whitespace-pre'>
                                                    <tr className='border-b-2 '>
                                                        <th className='p-[10px] '>
                                                            {tableValues?.[Fields?.template]?.length > 1 ?
                                                                <m.div {...zoomIn} className='flex items-center'>
                                                                    <InputCompo checked={isCheckedAll} onClick={(e) => { CheckAllFields(e, Fields.template) }} className='w-[25px] h-[25px] rounded-lg mr-auto ml-auto mt-auto mb-auto' type={'checkbox'} />
                                                                </m.div>
                                                                :
                                                                <>
                                                                    <div className='w-[25px]'> </div>
                                                                </>
                                                            }
                                                        </th>
                                                        <th className='p-[10px]'>
                                                            No.
                                                        </th >
                                                        {
                                                            Fields?.sub_questions?.map(subQ =>

                                                                <>
                                                                    <th className=' min-w-[200px] p-[10px]'>
                                                                        {subQ.question}
                                                                    </th >


                                                                </>
                                                            )}

                                                    </tr >
                                                    {tableValues?.[Fields?.template]?.map((values, index) =>
                                                        <tr className='border-b-2'>
                                                            <td className='p-[10px] '>

                                                                {tableValues?.[Fields?.template]?.length > 1 ?
                                                                    <m.div {...zoomIn} className='flex items-center'>
                                                                        <InputCompo
                                                                            checked={values?.check}
                                                                            onClick={(e) => CheckAllFields(e, index, Fields?.template)}
                                                                            type='checkbox' className='w-[25px] h-[25px] mr-auto ml-auto mt-auto mb-auto' />
                                                                    </m.div>
                                                                    :
                                                                    <>
                                                                        <div className='w-[25px]'>
                                                                        </div>
                                                                    </>
                                                                }

                                                            </td >
                                                            <td className='text-start p-[10px]'>
                                                                {1}
                                                            </td >
                                                            {
                                                                Fields?.sub_questions?.map(subQ =>
                                                                    <>
                                                                        {
                                                                            subQ.type.toLowerCase() === 'dropdown'
                                                                                ?
                                                                                <td className='p-[10px]'>
                                                                                    <div className='w-[100%]'>
                                                                                        <CustomSelection
                                                                                            options={subQ.options}
                                                                                            onChange={(e) => tableValuesUpdate(e, index, Fields?.template)} value={values?.[subQ.question_no]}
                                                                                            name={subQ.question_no}
                                                                                            label="Select" />
                                                                                    </div>

                                                                                </td>
                                                                                :
                                                                                subQ.type.toLowerCase() === 'text' || subQ.type.toLowerCase() === 'number' || subQ.type.toLowerCase() === 'date'
                                                                                    ?
                                                                                    <td className='p-[10px]'>
                                                                                        <div className='w-[100%]'>
                                                                                            <CustomInput options={subQ?.options} type={subQ?.type?.toLowerCase()}
                                                                                                onChange={(e) => tableValuesUpdate(e, index, Fields?.template)} value={values?.[subQ.question_no]}
                                                                                                name={subQ.question_no}
                                                                                                label={subQ.type.toLowerCase() === 'date' ? 'mm/dd/yyyy' : "Text here"} />
                                                                                        </div>

                                                                                    </td >
                                                                                    :
                                                                                    subQ.type.toLowerCase() === 'attach'
                                                                                        ?
                                                                                        <td className='p-[10px]'>
                                                                                            <div className='w-[100%]'>
                                                                                                {/* {values?.[subQ?.question_no]?.fileName}  */}
                                                                                                <CustomFileInput
                                                                                                    onChange={(e) => tableValuesUpdate(e, index, Fields?.template)}
                                                                                                    value={values?.[subQ?.question_no]?.fileName}
                                                                                                    name={subQ.question_no}
                                                                                                    label="Select" />
                                                                                            </div>

                                                                                        </td >
                                                                                        :
                                                                                        subQ.type.toLowerCase() === 'multiselect dropdown'
                                                                                            ?
                                                                                            <td className='p-[10px] max-w-[200px]'>
                                                                                                <div className='w-[100%]'>
                                                                                                    <MultipleSelect
                                                                                                        // maxSelect={}
                                                                                                        required={subQ?.mandatory > 0 ? true : false}
                                                                                                        options={subQ?.options}
                                                                                                        mappingKey="option" // Pass mapping key if needed
                                                                                                        onValueChange={(name, values) => selectedValues(name, values, index, Fields.template)}
                                                                                                        selectedValues={values?.[subQ?.question_no] || []}
                                                                                                        name={subQ.question_no}
                                                                                                        label={subQ?.question}
                                                                                                    />
                                                                                                </div>
                                                                                            </td >
                                                                                            : ''
                                                                        }
                                                                    </>
                                                                )}
                                                        </tr >
                                                    )}

                                                </table >
                                            </div >

                                        </div >
                                    </>
                                    : ''

                            }
                        </>
                    ))}


                </div >
                {/* {
                    questions?.docs_answers.length > 0 ?
                        ''
                        : */}
                        <div className='flex justify-end'>
                            <ButtonComp type={'submit'} className='px-[20px] py-[6px] h-[40px] text-white bg-[#004878] rounded-full' text='Save & Next' />
                        </div>
                {/* } */}
            </form >
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['comment']} closeModal={commonEditCloseModal} >
                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Comment' />
                <ParagraphComp className='text-lg text-black text-center' >
                    {isModalOpen?.type?.toLowerCase() === 'section' ?
                        ((questions?.docs_answers?.length > 0 &&
                            Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
                            questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator' :
                        (questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator.'}
                </ParagraphComp>
                <div className="flex justify-end">
                    <ButtonComp onClick={commonEditCloseModal} type='button' className=' mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]'>
                        Close
                    </ButtonComp>
                </div>
            </ModalComp>
            <ModalComp width={'45%'} modalIsOpen={isModalOpen?.['edit']} closeModal={commonEditCloseModal} >
                {console.log("isModalOpen>>>>>", isModalOpen)}
                <Formik
                    enableReinitialize
                    initialValues={{
                        [isModalOpen?.data?.question_no || 'default_question_no']: '',
                    }}
                    validationSchema={editModalSchema}
                    onSubmit={(values) => {
                        updateValues(values);
                    }}
                >


                    {({ values: modalValues, errors: modalErrors, handleChange, setFieldValue: setModalFieldValue }) => (

                        <Form action="">
                            {console.log("modalErrors>>>>", modalErrors)}
                            <div className='h-auto'>
                                <div className='flex justify-end'>
                                    <div className='cursor-pointer' onClick={commonEditCloseModal}>
                                        <CloseIcon />
                                    </div>
                                </div>
                                <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Edit' />
                                <ParagraphComp className='text-lg text-black text-start' text='Question' />
                                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' text={isModalOpen?.data?.question} />
                                {(isModalOpen?.type?.toLowerCase() === 'section' ?
                                    formik?.values?.[isModalOpen?.template]?.[isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                                    (questions?.docs_answers?.length > 0 &&
                                        Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer) &&
                                        questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || '' :
                                    formik?.values?.normalFields?.[isModalOpen?.data?.question_no] ||
                                    (questions?.docs_answers?.length > 0 &&
                                        questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer))
                                    ?
                                    <ParagraphComp className='text-lg mt-[10px] text-black text-start' text='Current Answer' />
                                    : ''
                                }
                                <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' >

                                    {(isModalOpen?.type?.toLowerCase() === 'section' ?
                                        formik?.values?.[isModalOpen?.template]?.[isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                                        ((questions?.docs_answers?.length > 0 &&
                                            Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
                                            questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || '' :
                                        formik?.values?.normalFields?.[isModalOpen?.data?.question_no] ||
                                        (questions?.docs_answers?.length > 0 &&
                                            questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer)) || ''}
                                </ParagraphComp>
                                {isModalOpen?.data?.type.toLowerCase() === 'text' || isModalOpen?.data?.type.toLowerCase() === 'number' || isModalOpen?.data?.type.toLowerCase() === 'date' || isModalOpen?.data?.type.toLowerCase() === 'password' ?
                                    < div className='mt-[20px]'>
                                        <CustomInput required={true}
                                            type={isModalOpen?.data?.type?.toLowerCase()}
                                            name={isModalOpen?.data?.question_no}
                                            value={modalValues?.[isModalOpen?.data?.question_no]}
                                            onChange={handleChange} label='New Answer' />
                                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                    </div>
                                    :
                                    isModalOpen?.data?.type.toLowerCase() === 'dropdown' ?
                                        < div className='mt-[20px]'>
                                            <CustomSelection
                                                imgKey='flag'
                                                exDataKey={isModalOpen?.data?.question === 'Country Code' ? 'label' : undefined}
                                                mappingKey={isModalOpen?.data?.question === 'Country Code' ? 'phone' : undefined}
                                                options={isModalOpen?.data?.options}
                                                required={true}
                                                value={modalValues?.[isModalOpen?.data.question_no]}
                                                onChange={handleChange}
                                                name={isModalOpen?.data.question_no}
                                                label='New Answer'
                                            />
                                            <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                        </div>
                                        : isModalOpen?.data?.type.toLowerCase() === 'multiselect dropdown' ?
                                            < div className='mt-[20px] w-[100%] flex gap-[20px] flex-wrap'>
                                                {isModalOpen?.data?.options?.map((subQ, multiIndex) => (
                                                    <div className="flex gap-[10px] w-[30%]">
                                                        <div className=" w-[100%]">
                                                            <label className="flex mt-[16px] items-center space-x-2">
                                                                <div className="w-[20px] h-[20px]">
                                                                    <InputCompo
                                                                        required={subQ?.mandatory > 0 ? true : false}
                                                                        options={subQ?.options}
                                                                        onChange={(e) =>
                                                                            updateModalMultiSelect(e, subQ.option, setModalFieldValue, modalValues)
                                                                        }
                                                                        checked={
                                                                            modalValues?.[
                                                                                isModalOpen?.data?.question_no
                                                                            ]?.includes(subQ?.option)
                                                                                ? true
                                                                                : false
                                                                        }
                                                                        name={isModalOpen?.data.question_no}
                                                                        className="bg-[#004878] text-white w-[20px] h-[20px]"
                                                                        type="checkbox"
                                                                    />
                                                                </div>

                                                                <span className='text-black'>{subQ.option}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            :
                                            isModalOpen?.data?.type.toLowerCase() === 'attach' ?
                                                <div className='mt-[20px]'>
                                                    <CustomFileInput
                                                        required={true}
                                                        onChange={(e) => attachFile(e, setModalFieldValue)}
                                                        value={modalValues?.[isModalOpen?.data?.question_no].file_name}
                                                        name={isModalOpen?.data?.question_no}
                                                        label="New Answer"
                                                    />
                                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                                                </div>
                                                : ''

                                }

                                <div className="flex justify-center mt-[15px]">
                                    <ButtonComp
                                        disabled={editLoading ? true : false}
                                        className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none"
                                        type="Submit"
                                        text={editLoading ? "Saving..." : "Save"}
                                    />
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ModalComp>
        </>
    );
};

export default SustainableDevelopment;
